// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1frxnkob>*{vertical-align:middle}\n._1k0l7vkz>*{line-height:1pc}\n._d0dzdf4r>*{display:inline-block!important}", ""]);
// Exports
module.exports = exports;
